(function () {
  if (window.__cbBdayInitV4) return;
  window.__cbBdayInitV4 = true;

  var CFG = window.CB_BDAY_CFG || {};
  var TEE_URL = CFG.tee;
  var GLASSES_URL = CFG.glasses;
  var HAT_URL = CFG.hat;
  var SAMPLE_URL = CFG.sample;
  var CLOUDINARY = { cloudName: "dkvg84nse", preset: "pk_personalise" };
  var LAYOUT = { W: 3300, H: 3960 };
  var BG_LIB = "https://esm.sh/@imgly/background-removal@1.6.0";
  var TFJS_FULL = "https://esm.sh/@tensorflow/tfjs@4.22.0";
  var BODYPIX = "https://esm.sh/@tensorflow-models/body-pix@2.2.1?deps=@tensorflow/tfjs@4.22.0";
  var TF_CORE = "https://esm.sh/@tensorflow/tfjs-core@4.22.0";
  var TF_WEBGL = "https://esm.sh/@tensorflow/tfjs-backend-webgl@4.22.0";
  var BLAZE = "https://esm.sh/@tensorflow-models/blazeface@0.1.0?deps=@tensorflow/tfjs-core@4.22.0,@tensorflow/tfjs-converter@4.22.0";
  var PARTY_FONT = '"Luckiest Guy","Arial Black",Impact,sans-serif';
  var NAME_FONT = '"DM Serif Display",Georgia,serif';
  var TXT_PINK = "#e6007e";
  var TXT_ORANGE = "#ff7a33";
  var COLOURS = [
    { n: "White", h: "#f5f5f2" },
    { n: "Black", h: "#1c1c1c" },
    { n: "Navy", h: "#26314a" },
    { n: "Red", h: "#a71f28" },
    { n: "Sport Grey", h: "#c7c7c7" },
    { n: "Dusty Pink", h: "#d9a7b4" }
  ];
  var DEFAULT = "White";
  var headCut = null;
  var headEye = null;
  var headWhite = null;
  var teeImg = null;
  var glassesImg = null;
  var hatImg = null;
  var sampleHead = null;
  var customerPhotoReady = false;
  var photoProcessing = false;
  var selectedLayer = "head";
  var DEFAULT_ADJ = {
    head: { x: 0, y: 0, scale: 1, rot: 0 },
    glasses: { x: 0, y: 0, scale: 1.12, rot: 0 },
    hat: { x: 0, y: -0.06, scale: 1, rot: 0 }
  };
  var ADJ = {
    head: { x: 0, y: 0, scale: 1, rot: 0 },
    glasses: { x: 0, y: 0, scale: 1.12, rot: 0 },
    hat: { x: 0, y: -0.06, scale: 1, rot: 0 }
  };
  var teeTintCache = {};

  function resetAdjustments(layer) {
    var keys = layer ? [layer] : ["head", "glasses", "hat"];
    keys.forEach(function (key) {
      ADJ[key].x = DEFAULT_ADJ[key].x;
      ADJ[key].y = DEFAULT_ADJ[key].y;
      ADJ[key].scale = DEFAULT_ADJ[key].scale;
      ADJ[key].rot = DEFAULT_ADJ[key].rot;
    });
  }

  function moveLayer(layer, direction, amount) {
    var minY = layer === "hat" ? -0.28 : (layer === "head" ? -0.10 : -0.28);
    var maxY = layer === "hat" ? 0.28 : 0.35;
    var step = amount || 0.035;
    if (direction === "left") ADJ[layer].x -= step;
    if (direction === "right") ADJ[layer].x += step;
    if (direction === "up") ADJ[layer].y -= step;
    if (direction === "down") ADJ[layer].y += step;
    ADJ[layer].x = Math.max(-0.35, Math.min(0.35, ADJ[layer].x));
    ADJ[layer].y = Math.max(minY, Math.min(maxY, ADJ[layer].y));
  }

  function makeWhiteSilhouette(source) {
    if (!source) return null;
    var c = document.createElement("canvas");
    c.width = source.width;
    c.height = source.height;
    var x = c.getContext("2d");
    x.drawImage(source, 0, 0);
    x.globalCompositeOperation = "source-in";
    x.fillStyle = "#ffffff";
    x.fillRect(0, 0, c.width, c.height);
    return c;
  }

  function chosen() {
    var c = document.querySelector('[data-cb-sw="Colour"] input:checked');
    return c ? c.value : DEFAULT;
  }

  function shirtHex() {
    var c = chosen();
    for (var i = 0; i < COLOURS.length; i++) if (COLOURS[i].n === c) return COLOURS[i].h;
    return COLOURS[0].h;
  }

  function mode() {
    var m = document.querySelector("[data-cb-mode] input:checked");
    return m ? m.value : "crew";
  }

  function val(s) {
    var e = document.querySelector(s);
    return e ? (e.value || "").trim() : "";
  }

  function ord(a) {
    var n = parseInt(a, 10);
    if (isNaN(n)) return (a || "").toString().toUpperCase();
    var v = n % 100;
    var s = ["TH", "ST", "ND", "RD"];
    return n + (v >= 11 && v <= 13 ? "TH" : s[n % 10] || "TH");
  }

  function loadImg(url) {
    return new Promise(function (res, rej) {
      var im = new Image();
      im.crossOrigin = "anonymous";
      im.onload = function () { res(im); };
      im.onerror = rej;
      im.src = url;
    });
  }

  function loadBg() {
    return new Promise(function (res, rej) {
      if (window.__imglyRemove) return res(window.__imglyRemove);
      var s = document.createElement("script");
      s.type = "module";
      s.textContent = "import { removeBackground } from '" + BG_LIB + "'; window.__imglyRemove=removeBackground; window.dispatchEvent(new Event('cbimglyready'));";
      window.addEventListener("cbimglyready", function () { res(window.__imglyRemove); }, { once: true });
      s.onerror = function () { rej(new Error("bg lib")); };
      document.head.appendChild(s);
    });
  }

  function loadFace() {
    return new Promise(function (res, rej) {
      if (window.__bbFace) return res(window.__bbFace);
      if (window.__bbFaceErr) return rej(window.__bbFaceErr);
      var s = document.createElement("script");
      s.type = "module";
      s.textContent = "import * as tf from '" + TF_CORE + "';import '" + TF_WEBGL + "';import * as bf from '" + BLAZE + "';(async()=>{try{await tf.setBackend('webgl');await tf.ready();window.__bbFace=await bf.load();}catch(e){window.__bbFaceErr=e;}window.dispatchEvent(new Event('bbfaceready'));})();";
      window.addEventListener("bbfaceready", function () {
        window.__bbFace ? res(window.__bbFace) : rej(window.__bbFaceErr || new Error("face"));
      }, { once: true });
      s.onerror = function () { rej(new Error("face lib")); };
      document.head.appendChild(s);
    });
  }

  function loadHeadModel() {
    if (window.__cbHeadNet) return Promise.resolve(window.__cbHeadNet);
    if (window.__cbHeadErr) return Promise.reject(window.__cbHeadErr);
    if (window.__cbHeadPromise) return window.__cbHeadPromise;
    window.__cbHeadPromise = new Promise(function (res, rej) {
      if (window.__cbHeadNet) return res(window.__cbHeadNet);
      if (window.__cbHeadErr) return rej(window.__cbHeadErr);
      var s = document.createElement("script");
      s.type = "module";
      s.textContent = "import * as tf from '" + TFJS_FULL + "';import * as bp from '" + BODYPIX + "';(async()=>{try{await tf.setBackend('webgl');await tf.ready();window.__cbHeadNet=await bp.load({architecture:'MobileNetV1',outputStride:16,multiplier:0.75,quantBytes:2});}catch(e){window.__cbHeadErr=e;}window.dispatchEvent(new Event('cbheadready'));})();";
      window.addEventListener("cbheadready", function () {
        window.__cbHeadNet ? res(window.__cbHeadNet) : rej(window.__cbHeadErr || new Error("head model"));
      }, { once: true });
      s.onerror = function () { rej(new Error("head model")); };
      document.head.appendChild(s);
    });
    return window.__cbHeadPromise;
  }

  function segmentHead(model, source) {
    return model.segmentPersonParts(source, {
      flipHorizontal: false,
      internalResolution: "medium",
      segmentationThreshold: 0.55,
      maxDetections: 1
    });
  }

  function scanFaceTiles(model, source, grid) {
    var ratio = grid === 2 ? 0.62 : 0.42;
    var tw = Math.round(source.width * ratio);
    var th = Math.round(source.height * ratio);
    var sx = grid > 1 ? (source.width - tw) / (grid - 1) : 0;
    var sy = grid > 1 ? (source.height - th) / (grid - 1) : 0;
    var tiles = [];
    for (var gy = 0; gy < grid; gy++) {
      for (var gx = 0; gx < grid; gx++) {
        tiles.push({ x: Math.round(gx * sx), y: Math.round(gy * sy) });
      }
    }
    var found = [];
    var chain = Promise.resolve();
    tiles.forEach(function (tile) {
      chain = chain.then(function () {
        var c = document.createElement("canvas");
        c.width = tw;
        c.height = th;
        c.getContext("2d").drawImage(source, tile.x, tile.y, tw, th, 0, 0, tw, th);
        return model.estimateFaces(c, false).then(function (faces) {
          (faces || []).forEach(function (face) {
            found.push({
              probability: face.probability,
              topLeft: [face.topLeft[0] + tile.x, face.topLeft[1] + tile.y],
              bottomRight: [face.bottomRight[0] + tile.x, face.bottomRight[1] + tile.y],
              landmarks: face.landmarks.map(function (p) { return [p[0] + tile.x, p[1] + tile.y]; })
            });
          });
        });
      });
    });
    return chain.then(function () { return found; });
  }

  function detectFaces(model, source) {
    return model.estimateFaces(source, false).then(function (faces) {
      if (faces && faces.length) return faces;
      return scanFaceTiles(model, source, 2);
    });
  }

  function faceFromSilhouette(cutout) {
    var c = document.createElement("canvas");
    c.width = cutout.width;
    c.height = cutout.height;
    var x = c.getContext("2d", { willReadFrequently: true });
    x.drawImage(cutout, 0, 0);
    var d = x.getImageData(0, 0, c.width, c.height).data;
    var minX = c.width;
    var minY = c.height;
    var maxX = -1;
    var maxY = -1;
    var rows = [];
    for (var y = 0; y < c.height; y += 2) {
      var left = c.width;
      var right = -1;
      for (var xx = 0; xx < c.width; xx += 2) {
        if (d[(y * c.width + xx) * 4 + 3] > 40) {
          if (xx < left) left = xx;
          if (xx > right) right = xx;
        }
      }
      if (right >= left) {
        rows.push({ y: y, left: left, right: right, width: right - left + 1 });
        if (left < minX) minX = left;
        if (right > maxX) maxX = right;
        if (y < minY) minY = y;
        if (y > maxY) maxY = y;
      }
    }
    if (!rows.length) return { x: cutout.width / 2, y: cutout.height * 0.28, ed: cutout.width * 0.12 };
    var bw = maxX - minX + 1;
    var bh = maxY - minY + 1;
    var sampleStart = minY + bh * 0.04;
    var sampleEnd = minY + bh * 0.18;
    var sample = rows.filter(function (r) { return r.y >= sampleStart && r.y <= sampleEnd; }).map(function (r) { return r.width; }).sort(function (a, b) { return a - b; });
    var base = sample.length ? sample[Math.floor(sample.length / 2)] : bw * 0.34;
    var threshold = Math.max(base * 1.65, bw * 0.55);
    var searchStart = minY + bh * 0.12;
    var searchEnd = minY + bh * 0.48;
    var headBottom = -1;
    var run = 0;
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      if (row.y < searchStart || row.y > searchEnd) continue;
      run = row.width > threshold ? run + 1 : 0;
      if (run >= 4) {
        headBottom = row.y - 6;
        break;
      }
    }
    if (headBottom < 0) headBottom = minY + Math.min(bh * 0.32, bw * 0.68);
    var headRows = rows.filter(function (r) {
      return r.y >= minY + bh * 0.04 && r.y <= headBottom && r.width < threshold;
    });
    var centerX = headRows.length ? headRows.reduce(function (sum, r) { return sum + (r.left + r.right) / 2; }, 0) / headRows.length : (minX + maxX) / 2;
    return {
      x: centerX,
      y: minY + (headBottom - minY) * 0.42,
      ed: Math.max(18, Math.min(base * 0.36, bw * 0.18))
    };
  }

  function loadFont() {
    var l = document.createElement("link");
    l.rel = "stylesheet";
    l.href = "https://fonts.googleapis.com/css2?family=DM+Serif+Display&family=Luckiest+Guy&display=swap";
    document.head.appendChild(l);
    if (!document.fonts || !document.fonts.load) {
      return new Promise(function (r) { setTimeout(r, 700); });
    }
    return Promise.all([
      document.fonts.load('400 120px "Luckiest Guy"'),
      document.fonts.load('400 120px "DM Serif Display"')
    ]);
  }

  function fit(ctx, t, maxW, start, font) {
    var s = start;
    var family = font || PARTY_FONT;
    ctx.font = "400 " + s + "px " + family;
    while (ctx.measureText(t).width > maxW && s > 26) {
      s -= 6;
      ctx.font = "400 " + s + "px " + family;
    }
    return s;
  }

  function buildSw() {
    var box = document.querySelector('[data-cb-sw="Colour"]');
    if (!box || box.dataset.cbBuilt === "1") return;
    box.dataset.cbBuilt = "1";
    box.innerHTML = "";
    COLOURS.forEach(function (c) {
      var l = document.createElement("label");
      l.title = c.n;
      l.innerHTML = '<input type="radio" name="cbcol" value="' + c.n + '"' + (c.n === DEFAULT ? " checked" : "") + '><span style="background:' + c.h + '"></span>';
      box.appendChild(l);
    });
  }

  function rounded(ctx, x, y, w, h, r) {
    ctx.beginPath();
    ctx.moveTo(x + r, y);
    ctx.arcTo(x + w, y, x + w, y + h, r);
    ctx.arcTo(x + w, y + h, x, y + h, r);
    ctx.arcTo(x, y + h, x, y, r);
    ctx.arcTo(x, y, x + w, y, r);
    ctx.closePath();
  }

  function arcText(ctx, text, cx, cy, radius, start, end) {
    text = (text || "").toUpperCase();
    var chars = text.split("");
    var step = chars.length > 1 ? (end - start) / (chars.length - 1) : 0;
    ctx.save();
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    for (var i = 0; i < chars.length; i++) {
      var a = start + step * i;
      ctx.save();
      ctx.translate(cx + Math.cos(a) * radius, cy + Math.sin(a) * radius);
      ctx.rotate(a + Math.PI / 2);
      if (ctx.lineWidth > 0) ctx.strokeText(chars[i], 0, 0);
      ctx.fillText(chars[i], 0, 0);
      ctx.restore();
    }
    ctx.restore();
  }

  function shallowArcText(ctx, text, cx, topY, width, curve) {
    text = (text || "").toUpperCase();
    var chars = text.split("");
    ctx.save();
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    for (var i = 0; i < chars.length; i++) {
      var t = chars.length > 1 ? i / (chars.length - 1) * 2 - 1 : 0;
      ctx.save();
      ctx.translate(cx + t * width / 2, topY + curve * t * t);
      ctx.rotate(t * 0.14);
      if (ctx.lineWidth > 0) ctx.strokeText(chars[i], 0, 0);
      ctx.fillText(chars[i], 0, 0);
      ctx.restore();
    }
    ctx.restore();
  }

  function cropFace(cutout, emx, emy, ed) {
    var cl = emx - 2.45 * ed;
    var ct = emy - 3.0 * ed;
    var cr = emx + 2.45 * ed;
    var cb = emy + 2.65 * ed;
    var cw = Math.max(1, Math.round(cr - cl));
    var ch = Math.max(1, Math.round(cb - ct));
    var c = document.createElement("canvas");
    c.width = cw;
    c.height = ch;
    var x = c.getContext("2d");
    x.drawImage(cutout, Math.round(-cl), Math.round(-ct));
    var full = x.getImageData(0, 0, cw, ch);
    var fd = full.data;
    var borderOpaque = 0;
    var borderCount = 0;
    var borderStep = Math.max(1, Math.round(Math.min(cw, ch) / 90));
    function countBorder(px, py) {
      borderCount++;
      if (fd[(py * cw + px) * 4 + 3] > 200) borderOpaque++;
    }
    for (var bx = 0; bx < cw; bx += borderStep) {
      countBorder(bx, 0);
    }
    for (var by = 0; by < ch * 0.68; by += borderStep) {
      countBorder(0, by);
      countBorder(cw - 1, by);
    }
    var needsFallbackMask = borderCount > 0 && borderOpaque / borderCount > 0.55;
    var eyeXc = emx - cl;
    var eyeYc = emy - ct;

    if (needsFallbackMask) {
      var bg = [];
      function sampleBg(px, py) {
        var p = (py * cw + px) * 4;
        if (fd[p + 3] > 180) bg.push([fd[p], fd[p + 1], fd[p + 2]]);
      }
      var sampleStepX = Math.max(1, Math.round(cw / 14));
      var sampleStepY = Math.max(1, Math.round(ch / 14));
      for (var sx = 0; sx < cw; sx += sampleStepX) sampleBg(sx, 0);
      for (var sy = 0; sy < ch * 0.62; sy += sampleStepY) {
        sampleBg(0, sy);
        sampleBg(cw - 1, sy);
      }

      var maskX = eyeXc;
      var maskY = eyeYc + ed * 0.22;
      var maskRX = ed * 2.10;
      var maskRY = ed * 2.55;
      for (var my = 0; my < ch; my++) {
        for (var mx = 0; mx < cw; mx++) {
          var pi = (my * cw + mx) * 4;
          if (fd[pi + 3] < 2) continue;
          var dx = (mx - maskX) / maskRX;
          var dy = (my - maskY) / maskRY;
          var radius = Math.sqrt(dx * dx + dy * dy);
          var keep = 1;
          if (radius > 0.72) {
            keep = Math.max(0, Math.min(1, (1 - radius) / 0.28));
            keep = keep * keep * (3 - 2 * keep);
          }
          if (radius > 0.42 && bg.length) {
            var nearest = 1e9;
            for (var bi = 0; bi < bg.length; bi++) {
              var dr = fd[pi] - bg[bi][0];
              var dg = fd[pi + 1] - bg[bi][1];
              var db = fd[pi + 2] - bg[bi][2];
              var distance = dr * dr + dg * dg + db * db;
              if (distance < nearest) nearest = distance;
            }
            var colourKeep = 1;
            if (nearest < 24 * 24) colourKeep = 0;
            else if (nearest < 58 * 58) colourKeep = (Math.sqrt(nearest) - 24) / 34;
            var outerWeight = Math.max(0, Math.min(1, (radius - 0.42) / 0.38));
            keep *= 1 - outerWeight * (1 - colourKeep);
          }
          fd[pi + 3] *= keep;
        }
      }
    }

    function rowW(y2) {
      var w2 = 0;
      var row = y2 * cw * 4;
      for (var i = 0; i < cw; i++) if (fd[row + i * 4 + 3] > 60) w2++;
      return w2;
    }
    var chinY = Math.max(0, Math.round(eyeYc + 1.1 * ed));
    var endY = Math.min(ch - 1, Math.round(eyeYc + 2.7 * ed));
    var neckY = chinY;
    var minW = 1e9;
    if (needsFallbackMask) {
      neckY = Math.min(ch - 1, Math.round(eyeYc + 1.65 * ed));
    } else {
      for (var y = chinY; y <= endY; y++) {
        var w = rowW(y);
        if (w < minW) { minW = w; neckY = y; }
      }
    }
    var fade = Math.max(2, Math.round((needsFallbackMask ? 0.45 : 0.12) * ed));
    for (var yy = neckY; yy < ch; yy++) {
      var f = Math.max(0, 1 - (yy - neckY) / fade);
      var r2 = yy * cw * 4;
      for (var xx = 0; xx < cw; xx++) fd[r2 + xx * 4 + 3] *= f;
    }
    for (var ai = 3; ai < fd.length; ai += 4) {
      var alpha = fd[ai];
      if (alpha < 24) {
        fd[ai] = 0;
      } else if (alpha < 180) {
        var edge = (alpha - 24) / 156;
        edge = edge * edge * (3 - 2 * edge);
        fd[ai] = Math.round(alpha * edge);
      }
    }
    x.putImageData(full, 0, 0);
    var d2 = x.getImageData(0, 0, cw, ch).data;
    var minx = cw, miny = ch, maxx = 0, maxy = 0, any = false;
    for (var yb = 0; yb < ch; yb++) {
      for (var xb = 0; xb < cw; xb++) {
        if (d2[(yb * cw + xb) * 4 + 3] > 25) {
          any = true;
          if (xb < minx) minx = xb;
          if (xb > maxx) maxx = xb;
          if (yb < miny) miny = yb;
          if (yb > maxy) maxy = yb;
        }
      }
    }
    if (!any) {
      headEye = { x: emx - cl, y: emy - ct, ed: ed };
      return c;
    }
    var tw = maxx - minx + 1;
    var th = maxy - miny + 1;
    var t = document.createElement("canvas");
    t.width = tw;
    t.height = th;
    t.getContext("2d").drawImage(c, minx, miny, tw, th, 0, 0, tw, th);
    headEye = { x: emx - cl - minx, y: emy - ct - miny, ed: ed };
    return t;
  }

  function applyHeadPartMask(cutout, segmentation, emx, emy, ed, sourceWidth, sourceHeight) {
    if (!segmentation || !segmentation.data || !segmentation.width || !segmentation.height) return null;
    var sw = segmentation.width;
    var sh = segmentation.height;
    var parts = segmentation.data;
    var total = sw * sh;
    var seedX = Math.max(0, Math.min(sw - 1, Math.round(emx / sourceWidth * sw)));
    var seedY = Math.max(0, Math.min(sh - 1, Math.round(emy / sourceHeight * sh)));
    var seed = seedY * sw + seedX;
    function isHead(index) {
      return parts[index] === 0 || parts[index] === 1;
    }
    if (!isHead(seed)) {
      var searchRadius = Math.max(20, Math.round(ed / sourceWidth * sw * 1.6));
      var best = -1;
      var bestDistance = Infinity;
      var fromY = Math.max(0, seedY - searchRadius);
      var toY = Math.min(sh - 1, seedY + searchRadius);
      var fromX = Math.max(0, seedX - searchRadius);
      var toX = Math.min(sw - 1, seedX + searchRadius);
      for (var sy = fromY; sy <= toY; sy++) {
        for (var sx = fromX; sx <= toX; sx++) {
          var candidate = sy * sw + sx;
          if (!isHead(candidate)) continue;
          var distance = (sx - seedX) * (sx - seedX) + (sy - seedY) * (sy - seedY);
          if (distance < bestDistance) {
            best = candidate;
            bestDistance = distance;
          }
        }
      }
      seed = best;
    }
    if (seed < 0 || !isHead(seed)) return null;

    var component = new Uint8Array(total);
    var queue = new Int32Array(total);
    var queueStart = 0;
    var queueEnd = 0;
    component[seed] = 1;
    queue[queueEnd++] = seed;
    while (queueStart < queueEnd) {
      var current = queue[queueStart++];
      var cy = Math.floor(current / sw);
      var cx = current - cy * sw;
      var minNeighbourY = Math.max(0, cy - 1);
      var maxNeighbourY = Math.min(sh - 1, cy + 1);
      var minNeighbourX = Math.max(0, cx - 1);
      var maxNeighbourX = Math.min(sw - 1, cx + 1);
      for (var ny = minNeighbourY; ny <= maxNeighbourY; ny++) {
        for (var nx = minNeighbourX; nx <= maxNeighbourX; nx++) {
          var neighbour = ny * sw + nx;
          if (!component[neighbour] && isHead(neighbour)) {
            component[neighbour] = 1;
            queue[queueEnd++] = neighbour;
          }
        }
      }
    }

    var mask = document.createElement("canvas");
    mask.width = sw;
    mask.height = sh;
    var maskContext = mask.getContext("2d");
    var maskImage = maskContext.createImageData(sw, sh);
    for (var mi = 0; mi < total; mi++) {
      if (component[mi]) {
        maskImage.data[mi * 4] = 255;
        maskImage.data[mi * 4 + 1] = 255;
        maskImage.data[mi * 4 + 2] = 255;
        maskImage.data[mi * 4 + 3] = 255;
      }
    }
    maskContext.putImageData(maskImage, 0, 0);

    var expanded = document.createElement("canvas");
    expanded.width = sw;
    expanded.height = sh;
    var expandedContext = expanded.getContext("2d");
    var dilation = Math.max(2, Math.min(10, Math.round(ed / sourceWidth * sw * 0.045)));
    for (var di = 0; di < 24; di++) {
      var angle = Math.PI * 2 * di / 24;
      expandedContext.drawImage(mask, Math.cos(angle) * dilation, Math.sin(angle) * dilation);
    }
    expandedContext.drawImage(mask, 0, 0);

    var feathered = document.createElement("canvas");
    feathered.width = sw;
    feathered.height = sh;
    var featheredContext = feathered.getContext("2d");
    featheredContext.filter = "blur(" + Math.max(1, Math.round(dilation * 0.35)) + "px)";
    featheredContext.drawImage(expanded, 0, 0);

    var output = document.createElement("canvas");
    output.width = cutout.naturalWidth || cutout.width;
    output.height = cutout.naturalHeight || cutout.height;
    var outputContext = output.getContext("2d", { willReadFrequently: true });
    outputContext.drawImage(cutout, 0, 0, output.width, output.height);
    var outputImage = outputContext.getImageData(0, 0, output.width, output.height);

    var scaledMask = document.createElement("canvas");
    scaledMask.width = output.width;
    scaledMask.height = output.height;
    var scaledMaskContext = scaledMask.getContext("2d", { willReadFrequently: true });
    scaledMaskContext.drawImage(feathered, 0, 0, output.width, output.height);
    var scaledMaskData = scaledMaskContext.getImageData(0, 0, output.width, output.height).data;
    for (var oi = 3; oi < outputImage.data.length; oi += 4) {
      outputImage.data[oi] = Math.round(outputImage.data[oi] * scaledMaskData[oi] / 255);
    }
    outputContext.putImageData(outputImage, 0, 0);
    return {
      canvas: output,
      eyeX: emx / sourceWidth * output.width,
      eyeY: emy / sourceHeight * output.height,
      eyeDistance: ed / sourceWidth * output.width
    };
  }

  function cropHeadSilhouette(source, emx, emy, ed) {
    var width = source.width;
    var height = source.height;
    var context = source.getContext("2d", { willReadFrequently: true });
    var pixels = context.getImageData(0, 0, width, height).data;
    var minX = width;
    var minY = height;
    var maxX = -1;
    var maxY = -1;
    for (var y = 0; y < height; y++) {
      for (var x = 0; x < width; x++) {
        if (pixels[(y * width + x) * 4 + 3] > 18) {
          minX = Math.min(minX, x);
          minY = Math.min(minY, y);
          maxX = Math.max(maxX, x);
          maxY = Math.max(maxY, y);
        }
      }
    }
    if (maxX < minX || maxY < minY) return null;
    var padding = Math.max(4, Math.round(ed * 0.09));
    minX = Math.max(0, minX - padding);
    minY = Math.max(0, minY - padding);
    maxX = Math.min(width - 1, maxX + padding);
    maxY = Math.min(height - 1, maxY + padding);
    var cropped = document.createElement("canvas");
    cropped.width = maxX - minX + 1;
    cropped.height = maxY - minY + 1;
    cropped.getContext("2d").drawImage(
      source,
      minX,
      minY,
      cropped.width,
      cropped.height,
      0,
      0,
      cropped.width,
      cropped.height
    );
    return {
      canvas: cropped,
      eye: { x: emx - minX, y: emy - minY, ed: ed }
    };
  }

  function drawGlasses(ctx, x, y, eyeDistance, size, rotation) {
    if (!glassesImg) return;
    var w = eyeDistance * 2.48 * size;
    var h = w * glassesImg.naturalHeight / glassesImg.naturalWidth;
    ctx.save();
    ctx.translate(x, y);
    ctx.rotate(rotation || 0);
    ctx.drawImage(glassesImg, -w / 2, -h * 0.68, w, h);
    ctx.restore();
  }

  function drawHat(ctx, x, y, faceRadius, size, rotation, canvasWidth) {
    if (!hatImg) return;
    var w = faceRadius * 0.78 * size;
    var h = w * hatImg.naturalHeight / hatImg.naturalWidth;
    var angle = -0.18 + (rotation || 0);
    var corners = [
      [-w / 2, -h * 0.86],
      [w / 2, -h * 0.86],
      [-w / 2, h * 0.14],
      [w / 2, h * 0.14]
    ];
    var minY = Infinity;
    for (var i = 0; i < corners.length; i++) {
      var rotatedY = corners[i][0] * Math.sin(angle) + corners[i][1] * Math.cos(angle);
      minY = Math.min(minY, rotatedY);
    }
    var topPadding = (canvasWidth || 0) * 0.002;
    if (y + minY < topPadding) y += topPadding - (y + minY);
    ctx.save();
    ctx.translate(x, y);
    ctx.rotate(angle);
    ctx.drawImage(hatImg, -w / 2, -h * 0.86, w, h);
    ctx.restore();
  }

  function drawStickerHead(ctx, anchorX, anchorY, scale, rotation, DW) {
    if (!headCut) return;
    var pivotX = headEye ? headEye.x : headCut.width / 2;
    var pivotY = headEye ? headEye.y : headCut.height * 0.44;
    var fw = headCut.width * scale;
    var fh = headCut.height * scale;
    var fx = -pivotX * scale;
    var fy = -pivotY * scale;
    var outline = DW * 0.0095;
    ctx.save();
    ctx.translate(anchorX, anchorY);
    ctx.rotate(rotation || 0);
    if (headWhite) {
      for (var i = 0; i < 28; i++) {
        var a = Math.PI * 2 * i / 28;
        ctx.drawImage(
          headWhite,
          fx + Math.cos(a) * outline,
          fy + Math.sin(a) * outline,
          fw,
          fh
        );
      }
    }
    ctx.drawImage(headCut, fx, fy, fw, fh);
    ctx.restore();
  }

  function drawConfetti(ctx, W, H) {
    var bits = [
      [0.16, 0.20, TXT_PINK, 18], [0.76, 0.18, "#2bb9e8", -22], [0.18, 0.32, "#20a96b", -38],
      [0.84, 0.31, TXT_ORANGE, 33], [0.13, 0.43, "#ffc400", -12], [0.80, 0.44, TXT_PINK, 24],
      [0.28, 0.15, "#2bb9e8", 42], [0.68, 0.13, "#20a96b", -28], [0.24, 0.47, TXT_ORANGE, 12],
      [0.73, 0.49, "#ffc400", -42], [0.10, 0.29, "#7f65d9", 30], [0.89, 0.24, "#20a96b", -14],
      [0.34, 0.09, "#ffc400", 22], [0.61, 0.10, TXT_PINK, -35], [0.31, 0.44, "#7f65d9", 17],
      [0.68, 0.42, "#2bb9e8", -18]
    ];
    ctx.save();
    bits.forEach(function (b, i) {
      ctx.translate(b[0] * W, b[1] * H);
      ctx.rotate(b[3] * Math.PI / 180);
      ctx.fillStyle = b[2];
      if (i % 4 === 0) {
        ctx.beginPath();
        ctx.arc(0, 0, W * 0.009, 0, Math.PI * 2);
        ctx.fill();
      } else {
        rounded(ctx, -W * 0.014, -H * 0.004, W * 0.028, H * 0.008, W * 0.004);
        ctx.fill();
      }
      ctx.setTransform(1, 0, 0, 1, 0, 0);
    });
    ctx.restore();
  }

  function drawDesign(ctx, DW, name, age, md) {
    var DH = Math.round(DW * LAYOUT.H / LAYOUT.W);
    ctx.clearRect(0, 0, DW, DH);
    if (!headCut) return;
    var nm = (name || "KAREN").toUpperCase();
    var ag = ord(age || "30");
    var agNumber = /^\d/.test(ag) ? ag.slice(0, -2) : ag;
    var agSuffix = /^\d/.test(ag) ? ag.slice(-2).toLowerCase() : "";

    drawConfetti(ctx, DW, DH);

    var faceR = DW * 0.225;
    var headRotation = ADJ.head.rot * Math.PI / 180;
    var anchorX = DW * 0.50 + ADJ.head.x * DW;
    var anchorY = DH * 0.31 - faceR * 0.07 + ADJ.head.y * DH;
    var scale;
    if (headEye && headEye.ed > 0) {
      scale = faceR * 0.70 / headEye.ed;
    } else {
      scale = faceR * 2.18 / headCut.width;
    }
    scale = Math.min(scale, DW * 0.65 / headCut.width, DH * 0.50 / headCut.height) * ADJ.head.scale;
    var glassesD = headEye ? headEye.ed * scale : faceR * 0.70 * ADJ.head.scale;
    var effectiveFaceR = glassesD / 0.70;
    drawStickerHead(ctx, anchorX, anchorY, scale, headRotation, DW);

    var hatOffsetX = -effectiveFaceR * 0.64;
    var hatOffsetY = -effectiveFaceR * 0.30;
    var hatX = anchorX + hatOffsetX * Math.cos(headRotation) - hatOffsetY * Math.sin(headRotation) + ADJ.hat.x * DW;
    var hatY = anchorY + hatOffsetX * Math.sin(headRotation) + hatOffsetY * Math.cos(headRotation) + ADJ.hat.y * DH;
    drawHat(
      ctx,
      hatX,
      hatY,
      effectiveFaceR,
      ADJ.hat.scale,
      headRotation + ADJ.hat.rot * Math.PI / 180,
      DW
    );

    drawGlasses(
      ctx,
      anchorX + ADJ.glasses.x * DW,
      anchorY + ADJ.glasses.y * DH,
      glassesD,
      ADJ.glasses.scale,
      headRotation + ADJ.glasses.rot * Math.PI / 180
    );

    function line(txt, y, size, col, max, x, font, rotation) {
      var family = font || PARTY_FONT;
      var s = fit(ctx, txt, max || DW * 0.88, size, family);
      var cx = typeof x === "number" ? x : DW / 2;
      ctx.save();
      ctx.translate(cx, y);
      ctx.rotate(rotation || 0);
      ctx.font = "400 " + s + "px " + family;
      ctx.lineWidth = Math.max(9, s * 0.075);
      ctx.lineJoin = "round";
      ctx.strokeStyle = "#fffdf7";
      ctx.strokeText(txt, 0, 0);
      ctx.fillStyle = col;
      ctx.fillText(txt, 0, 0);
      ctx.restore();
      return s;
    }

    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.font = "400 " + Math.round(DW * 0.105) + "px " + NAME_FONT;
    ctx.fillStyle = "#111111";
    ctx.strokeStyle = "#fffdf7";
    ctx.lineWidth = Math.round(DW * 0.008);
    ctx.lineJoin = "round";

    function drawAge(x, y) {
      var ax = typeof x === "number" ? x : DW * 0.80;
      var ay = typeof y === "number" ? y : DH * 0.35;
      line(agNumber, ay, Math.round(DW * 0.12), "#111111", DW * 0.24, ax, NAME_FONT, -0.04);
      if (agSuffix) {
        line(agSuffix, ay - DW * 0.05, Math.round(DW * 0.052), "#111111", DW * 0.12, ax + DW * 0.085, NAME_FONT, -0.04);
      }
    }

    if (md === "person") {
      drawAge();
      line("I AM", DH * 0.58, Math.round(DW * 0.095), "#111111", DW * 0.52, DW * 0.5, NAME_FONT, 0.02);
      line(nm, DH * 0.72, Math.round(DW * 0.205), "#111111", DW * 0.90, DW * 0.5, PARTY_FONT, -0.025);
    } else {
      var nameText = nm + "'S";
      line(nameText, DH * 0.485, Math.round(DW * 0.074), "#111111", DW * 0.32, DW * 0.23, PARTY_FONT, -0.04);
      drawAge(DW * 0.79, DH * 0.485);
      line("BIRTHDAY", DH * 0.625, Math.round(DW * 0.18), "#111111", DW * 0.92, DW * 0.5, PARTY_FONT, -0.025);
      line("CREW", DH * 0.79, Math.round(DW * 0.22), "#111111", DW * 0.72, DW * 0.5, PARTY_FONT, 0.025);
    }
  }

  window.CB_BDAY_RENDER_ARTWORK = function (canvas, width, name, age, designMode) {
    if (!canvas || !headCut) return false;
    var renderWidth = Math.max(320, Number(width) || 1200);
    canvas.width = renderWidth;
    canvas.height = Math.round(renderWidth * LAYOUT.H / LAYOUT.W);
    drawDesign(canvas.getContext("2d"), renderWidth, name, age, designMode || "crew");
    return true;
  };

  function tintTee() {
    if (!teeImg) return null;
    var colour = chosen();
    if (colour === "White") return teeImg;
    if (teeTintCache[colour]) return teeTintCache[colour];
    var hex = shirtHex().replace("#", "");
    var tr = parseInt(hex.slice(0, 2), 16);
    var tg = parseInt(hex.slice(2, 4), 16);
    var tb = parseInt(hex.slice(4, 6), 16);
    var c = document.createElement("canvas");
    c.width = teeImg.naturalWidth || teeImg.width;
    c.height = teeImg.naturalHeight || teeImg.height;
    var x = c.getContext("2d", { willReadFrequently: true });
    x.drawImage(teeImg, 0, 0);
    try {
      var image = x.getImageData(0, 0, c.width, c.height);
      var d = image.data;
      for (var i = 0; i < d.length; i += 4) {
        if (d[i + 3] < 4) continue;
        var lum = (d[i] * 0.299 + d[i + 1] * 0.587 + d[i + 2] * 0.114);
        var shade = (lum - 224) / 224;
        if (shade < 0) {
          d[i] = Math.max(0, tr * (1 + shade * 0.78));
          d[i + 1] = Math.max(0, tg * (1 + shade * 0.78));
          d[i + 2] = Math.max(0, tb * (1 + shade * 0.78));
        } else {
          d[i] = Math.min(255, tr + (255 - tr) * shade * 1.9);
          d[i + 1] = Math.min(255, tg + (255 - tg) * shade * 1.9);
          d[i + 2] = Math.min(255, tb + (255 - tb) * shade * 1.9);
        }
      }
      x.putImageData(image, 0, 0);
      teeTintCache[colour] = c;
      return c;
    } catch (e) {
      console.warn("[cb-bday] tee colour preview", e);
      return teeImg;
    }
  }

  function drawGildanMockup(ctx, W, H) {
    ctx.clearRect(0, 0, W, H);
    ctx.fillStyle = "#f1f0ec";
    rounded(ctx, 0, 0, W, H, W * 0.04);
    ctx.fill();

    var photoTee = tintTee();
    if (photoTee) {
      var pad = W * 0.025;
      ctx.save();
      ctx.shadowColor = "rgba(0,0,0,.18)";
      ctx.shadowBlur = W * 0.035;
      ctx.shadowOffsetY = W * 0.018;
      ctx.drawImage(photoTee, pad, pad, W - pad * 2, H - pad * 2);
      ctx.restore();
      return;
    }

    ctx.save();
    ctx.translate(W * 0.06, H * 0.04);
    ctx.scale(W / 1000, H / 1000);
    ctx.fillStyle = "rgba(0,0,0,.12)";
    ctx.beginPath();
    ctx.ellipse(500, 875, 285, 28, 0, 0, Math.PI * 2);
    ctx.fill();

    var shirt = shirtHex();
    ctx.fillStyle = shirt;
    ctx.strokeStyle = "#d8d2ca";
    ctx.lineWidth = 5;
    ctx.beginPath();
    ctx.moveTo(272, 150);
    ctx.bezierCurveTo(230, 160, 160, 195, 80, 305);
    ctx.lineTo(168, 430);
    ctx.bezierCurveTo(210, 402, 240, 372, 268, 334);
    ctx.lineTo(268, 850);
    ctx.bezierCurveTo(402, 886, 598, 886, 732, 850);
    ctx.lineTo(732, 334);
    ctx.bezierCurveTo(760, 372, 790, 402, 832, 430);
    ctx.lineTo(920, 305);
    ctx.bezierCurveTo(840, 195, 770, 160, 728, 150);
    ctx.bezierCurveTo(665, 202, 590, 228, 500, 228);
    ctx.bezierCurveTo(410, 228, 335, 202, 272, 150);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();

    var shade = ctx.createLinearGradient(170, 160, 840, 875);
    shade.addColorStop(0, "rgba(255,255,255,.34)");
    shade.addColorStop(0.5, "rgba(255,255,255,0)");
    shade.addColorStop(1, "rgba(0,0,0,.10)");
    ctx.fillStyle = shade;
    ctx.fill();

    ctx.strokeStyle = "rgba(0,0,0,.16)";
    ctx.lineWidth = 4;
    ctx.beginPath();
    ctx.arc(500, 142, 86, 0.05, Math.PI - 0.05);
    ctx.stroke();
    ctx.strokeStyle = "rgba(0,0,0,.08)";
    ctx.lineWidth = 2;
    ctx.beginPath();
    ctx.moveTo(268, 334);
    ctx.lineTo(268, 832);
    ctx.moveTo(732, 334);
    ctx.lineTo(732, 832);
    ctx.stroke();
    ctx.restore();
  }

  function init() {
    var stage = document.querySelector("[data-cb-bday-stage]");
    if (!stage) return;
    var galleryRoot = stage.closest("[data-cb-bday-gallery]") || stage;
    var product = stage.closest(".product");
    var mediaWrapper = product && product.querySelector(".product__media-wrapper");
    if (product && mediaWrapper && !mediaWrapper.contains(galleryRoot)) {
      product.classList.remove("product--no-media");
      product.classList.add("grid--2-col-tablet", "cb-bday-product");
      mediaWrapper.appendChild(galleryRoot);
    }
    var canvas = stage.querySelector("canvas");
    var galleryImage = stage.querySelector("[data-cb-gallery-image]");
    var galleryButtons = galleryRoot.querySelectorAll("[data-cb-gallery-view]");
    var panel = document.querySelector("[data-cb-bday-panel]");
    var spin = stage.querySelector("[data-cb-bday-spin]");
    var fileInput = document.getElementById("cb-bday-photo");
    var scaleRow = document.getElementById("cb-bday-scale-row");
    var adjustRoot = document.querySelector("[data-cb-adjust]");
    var sizeControl = document.getElementById("cb-bday-layer-size");
    var rotateControl = document.getElementById("cb-bday-layer-rotate");
    buildSw();

    function showGalleryView(button) {
      if (!button) return;
      var showLive = button.dataset.cbGalleryView === "live";
      canvas.hidden = !showLive;
      if (galleryImage) {
        galleryImage.hidden = showLive;
        if (!showLive) {
          galleryImage.src = button.dataset.cbGallerySrc || "";
          galleryImage.alt = button.dataset.cbGalleryAlt || button.getAttribute("aria-label") || "";
        }
      }
      for (var i = 0; i < galleryButtons.length; i++) {
        var active = galleryButtons[i] === button;
        galleryButtons[i].classList.toggle("is-active", active);
        galleryButtons[i].setAttribute("aria-selected", active ? "true" : "false");
      }
    }

    function showLivePreview() {
      var liveButton = galleryRoot.querySelector('[data-cb-gallery-view="live"]');
      if (liveButton && !liveButton.classList.contains("is-active")) showGalleryView(liveButton);
    }

    galleryRoot.addEventListener("click", function (e) {
      var galleryButton = e.target.closest("[data-cb-gallery-view]");
      if (galleryButton) showGalleryView(galleryButton);
    });

    function useSample() {
      if (!sampleHead) return;
      headCut = sampleHead.cut;
      headWhite = sampleHead.white;
      headEye = sampleHead.eye ? {
        x: sampleHead.eye.x,
        y: sampleHead.eye.y,
        ed: sampleHead.eye.ed
      } : null;
      render();
    }

    if (TEE_URL) {
      loadImg(TEE_URL).then(function (im) {
        teeImg = im;
        teeTintCache = {};
        render();
      }).catch(function (e) {
        console.warn("[cb-bday] tee load", e);
      });
    }
    if (GLASSES_URL) {
      loadImg(GLASSES_URL).then(function (im) {
        glassesImg = im;
        render();
      }).catch(function (e) {
        console.warn("[cb-bday] glasses load", e);
      });
    }
    if (HAT_URL) {
      loadImg(HAT_URL).then(function (im) {
        hatImg = im;
        render();
      }).catch(function (e) {
        console.warn("[cb-bday] hat load", e);
      });
    }
    if (SAMPLE_URL) {
      loadImg(SAMPLE_URL).then(function (im) {
        var sampleEyeX = Number(CFG.sampleEyeX) || im.naturalWidth * 0.5;
        var sampleEyeY = Number(CFG.sampleEyeY) || im.naturalHeight * 0.46;
        var sampleEyeDistance = Number(CFG.sampleEyeDistance) || im.naturalWidth * 0.17;
        var cut = cropFace(
          im,
          sampleEyeX,
          sampleEyeY,
          sampleEyeDistance
        );
        sampleHead = {
          cut: cut,
          white: makeWhiteSilhouette(cut),
          eye: headEye ? { x: headEye.x, y: headEye.y, ed: headEye.ed } : null
        };
        if (!photoProcessing && !customerPhotoReady) useSample();
        loadHeadModel().then(function (model) {
          return segmentHead(model, im);
        }).then(function (segmentation) {
          var masked = applyHeadPartMask(
            im,
            segmentation,
            sampleEyeX,
            sampleEyeY,
            sampleEyeDistance,
            im.naturalWidth,
            im.naturalHeight
          );
          if (!masked) return;
          var precise = cropHeadSilhouette(
            masked.canvas,
            masked.eyeX,
            masked.eyeY,
            masked.eyeDistance
          );
          if (!precise) return;
          sampleHead = {
            cut: precise.canvas,
            white: makeWhiteSilhouette(precise.canvas),
            eye: precise.eye
          };
          if (!photoProcessing && !customerPhotoReady) useSample();
        }).catch(function (e) {
          console.warn("[cb-bday] sample head segmentation", e);
        });
      }).catch(function (e) {
        console.warn("[cb-bday] sample load", e);
      });
    }

    function render() {
      var dpr = Math.max(1, Math.min(2, window.devicePixelRatio || 1));
      var W = Math.round((canvas.clientWidth || 420) * dpr);
      var H = W;
      canvas.width = W;
      canvas.height = H;
      var ctx = canvas.getContext("2d");
      drawGildanMockup(ctx, W, H);

      var off = document.createElement("canvas");
      off.width = 1800;
      off.height = Math.round(off.width * LAYOUT.H / LAYOUT.W);
      drawDesign(off.getContext("2d"), off.width, val('[name="properties[Name]"]'), val('[name="properties[Age]"]'), mode());

      var printW = W * 0.38;
      var printH = printW * LAYOUT.H / LAYOUT.W;
      ctx.drawImage(off, W * 0.5 - printW / 2, H * 0.24, printW, printH);
    }

    function syncAdjustControls() {
      if (sizeControl) sizeControl.value = ADJ[selectedLayer].scale;
      if (rotateControl) rotateControl.value = ADJ[selectedLayer].rot;
      if (!adjustRoot) return;
      var buttons = adjustRoot.querySelectorAll("[data-cb-layer]");
      for (var i = 0; i < buttons.length; i++) {
        var active = buttons[i].dataset.cbLayer === selectedLayer;
        buttons[i].classList.toggle("is-active", active);
        buttons[i].setAttribute("aria-pressed", active ? "true" : "false");
      }
    }

    if (adjustRoot) {
      adjustRoot.addEventListener("click", function (e) {
        var layerButton = e.target.closest("[data-cb-layer]");
        if (layerButton) {
          showLivePreview();
          selectedLayer = layerButton.dataset.cbLayer;
          syncAdjustControls();
          return;
        }
        var moveButton = e.target.closest("[data-cb-move]");
        if (moveButton) {
          showLivePreview();
          moveLayer(selectedLayer, moveButton.dataset.cbMove);
          render();
          return;
        }
        if (e.target.closest("[data-cb-reset]")) {
          showLivePreview();
          resetAdjustments(selectedLayer);
          syncAdjustControls();
          render();
        }
      });
    }
    if (sizeControl) {
      sizeControl.addEventListener("input", function () {
        showLivePreview();
        ADJ[selectedLayer].scale = Number(sizeControl.value);
        render();
      });
    }
    if (rotateControl) {
      rotateControl.addEventListener("input", function () {
        showLivePreview();
        ADJ[selectedLayer].rot = Number(rotateControl.value);
        render();
      });
    }
    syncAdjustControls();

    var drag = null;
    canvas.addEventListener("pointerdown", function (e) {
      if (!headCut) return;
      showLivePreview();
      drag = { x: e.clientX, y: e.clientY, id: e.pointerId };
      canvas.classList.add("is-dragging");
      canvas.setPointerCapture && canvas.setPointerCapture(e.pointerId);
      e.preventDefault();
    });
    canvas.addEventListener("pointermove", function (e) {
      if (!drag || drag.id !== e.pointerId) return;
      var rect = canvas.getBoundingClientRect();
      var printW = rect.width * 0.38;
      var printH = printW * LAYOUT.H / LAYOUT.W;
      var minY = selectedLayer === "hat" ? -0.28 : (selectedLayer === "head" ? -0.10 : -0.28);
      var maxY = selectedLayer === "hat" ? 0.28 : 0.35;
      ADJ[selectedLayer].x = Math.max(-0.35, Math.min(0.35, ADJ[selectedLayer].x + (e.clientX - drag.x) / printW));
      ADJ[selectedLayer].y = Math.max(minY, Math.min(maxY, ADJ[selectedLayer].y + (e.clientY - drag.y) / printH));
      drag.x = e.clientX;
      drag.y = e.clientY;
      render();
      e.preventDefault();
    });
    function endDrag(e) {
      if (!drag || drag.id !== e.pointerId) return;
      drag = null;
      canvas.classList.remove("is-dragging");
      canvas.releasePointerCapture && canvas.releasePointerCapture(e.pointerId);
    }
    canvas.addEventListener("pointerup", endDrag);
    canvas.addEventListener("pointercancel", endDrag);

    panel && panel.addEventListener("input", function (e) {
      if (e.target && e.target.type === "file") return;
      showLivePreview();
      clearTimeout(window.__cbT);
      window.__cbT = setTimeout(render, 80);
    });
    document.addEventListener("change", function (e) {
      if (e.target && e.target.type === "file") return;
      render();
    });
    window.addEventListener("resize", render);
    loadFont().then(function () {
      render();
      setTimeout(render, 400);
      document.fonts && document.fonts.ready && document.fonts.ready.then(render);
    }).catch(render);

    fileInput && fileInput.addEventListener("change", function () {
      var f = fileInput.files && fileInput.files[0];
      if (!f) return;
      showLivePreview();
      photoProcessing = true;
      customerPhotoReady = false;
      spin && spin.classList.add("on");
      var pre = new Image();
      pre.onload = function () {
        var mx = 1600;
        var s = Math.min(1, mx / Math.max(pre.naturalWidth, pre.naturalHeight));
        var cn = document.createElement("canvas");
        cn.width = Math.round(pre.naturalWidth * s);
        cn.height = Math.round(pre.naturalHeight * s);
        cn.getContext("2d").drawImage(pre, 0, 0, cn.width, cn.height);
        var pDetect = loadFace().then(function (m) { return detectFaces(m, cn); }).catch(function (e) {
          console.warn("[cb-bday] no face detect", e);
          return null;
        });
        var pHead = loadHeadModel().then(function (m) { return segmentHead(m, cn); }).catch(function (e) {
          console.warn("[cb-bday] no head segmentation", e);
          return null;
        });
        cn.toBlob(function (png) {
          var pCut = loadBg().then(function (fn) { return fn(png); }).then(function (blob) {
            return new Promise(function (r, j) {
              var im = new Image();
              im.onload = function () { r(im); };
              im.onerror = j;
              im.src = URL.createObjectURL(blob);
            });
          });
          Promise.all([pCut, pDetect, pHead]).then(function (arr) {
            var cutout = arr[0];
            var faces = arr[1];
            var headSegmentation = arr[2];
            var emx, emy, ed;
            if (faces && faces.length) {
              var fc = faces.reduce(function (a, b) {
                return b.probability && a.probability && b.probability[0] > a.probability[0] ? b : a;
              });
              var re = fc.landmarks[0];
              var le = fc.landmarks[1];
              emx = (re[0] + le[0]) / 2;
              emy = (re[1] + le[1]) / 2;
              ed = Math.hypot(re[0] - le[0], re[1] - le[1]);
            } else {
              var estimate = faceFromSilhouette(cutout);
              emx = estimate.x;
              emy = estimate.y;
              ed = estimate.ed;
            }
            var maskedHead = headSegmentation && applyHeadPartMask(
              cutout,
              headSegmentation,
              emx,
              emy,
              ed,
              cn.width,
              cn.height
            );
            var preciseHead = maskedHead && cropHeadSilhouette(
              maskedHead.canvas,
              maskedHead.eyeX,
              maskedHead.eyeY,
              maskedHead.eyeDistance
            );
            if (preciseHead) {
              headCut = preciseHead.canvas;
              headEye = preciseHead.eye;
            } else {
              headCut = cropFace(cutout, emx, emy, ed);
            }
            headWhite = makeWhiteSilhouette(headCut);
            resetAdjustments();
            syncAdjustControls();
            customerPhotoReady = true;
            photoProcessing = false;
            if (scaleRow) scaleRow.style.display = "none";
            spin && spin.classList.remove("on");
            render();
          }).catch(function (err) {
            console.error("[cb-bday]", err);
            photoProcessing = false;
            customerPhotoReady = false;
            useSample();
            spin && spin.classList.remove("on");
            alert("Sorry, we could not process that photo - please try a clear, front-on face photo.");
          });
        }, "image/png");
      };
      pre.onerror = function () {
        photoProcessing = false;
        customerPhotoReady = false;
        useSample();
        spin && spin.classList.remove("on");
        alert("That image could not be read - please upload a JPG or PNG photo.");
      };
      pre.src = URL.createObjectURL(f);
    });

    function ov(m) {
      var o = document.getElementById("cb-bday-ov");
      if (!o) {
        o = document.createElement("div");
        o.id = "cb-bday-ov";
        o.style.cssText = "position:fixed;inset:0;background:rgba(0,0,0,.7);z-index:99999;display:flex;align-items:center;justify-content:center;color:#fff;font:600 18px sans-serif;text-align:center;padding:20px";
        document.body.appendChild(o);
      }
      o.textContent = m;
      o.style.display = "flex";
    }

    function hide() {
      var o = document.getElementById("cb-bday-ov");
      if (o) o.style.display = "none";
    }

    function upload(blob) {
      var fd = new FormData();
      fd.append("file", blob, "bday-" + Date.now() + ".png");
      fd.append("upload_preset", CLOUDINARY.preset);
      return fetch("https://api.cloudinary.com/v1_1/" + CLOUDINARY.cloudName + "/image/upload", { method: "POST", body: fd })
        .then(function (r) {
          if (!r.ok) throw new Error("cloudinary " + r.status);
          return r.json();
        }).then(function (j) {
          if (!j.secure_url) throw new Error("no url");
          return j.secure_url;
        });
    }

    function postJSON(props) {
      var vid = val('[name="id"]');
      if (!vid) throw new Error("no variant id");
      return fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1, properties: props }] })
      }).then(function (r) {
        return r.ok ? r.json() : r.json().then(function (j) { throw new Error(j.description || "HTTP " + r.status); });
      });
    }

    function openCart() {
      document.dispatchEvent(new CustomEvent("cart:refresh"));
      var d = document.querySelector("cart-drawer, cart-notification");
      if (d && d.open) {
        try { d.open(); return; } catch (e) {}
      }
      setTimeout(function () { window.location.href = "/cart"; }, 250);
    }

    var inFlight = false;
    var done = false;
    function atc(e) {
      if (done || inFlight) return;
      if (!customerPhotoReady) {
        alert("Please upload a photo of the birthday person first.");
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      var name = val('[name="properties[Name]"]');
      if (!name) {
        alert("Please enter the name.");
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      var age = val('[name="properties[Age]"]');
      if (!/^\d{1,3}$/.test(age)) {
        alert("Please enter the age using numbers.");
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation && e.stopImmediatePropagation();
      inFlight = true;
      ov("Creating your print file...");
      var pf = document.createElement("canvas");
      pf.width = LAYOUT.W;
      pf.height = LAYOUT.H;
      drawDesign(pf.getContext("2d"), LAYOUT.W, name, age, mode());
      new Promise(function (res) { pf.toBlob(function (b) { res(b); }, "image/png"); })
        .then(upload)
        .then(function (url) {
          ov("Adding to cart...");
          return postJSON({
            Name: name,
            Age: age,
            Type: mode() === "person" ? "Birthday Person" : "Birthday Crew",
            Colour: chosen(),
            Size: val('[name="properties[Size]"]'),
            _print_file: url,
            _editor_adjustments: JSON.stringify(ADJ),
            _print_author: "cb-birthday-v4"
          });
        })
        .then(function () {
          done = true;
          inFlight = false;
          hide();
          openCart();
        })
        .catch(function (err) {
          console.error("[cb-bday]", err);
          inFlight = false;
          done = false;
          hide();
          alert("Something went wrong adding to cart - please try again.");
        });
    }

    var addBtns = document.querySelectorAll('form[action*="/cart/add"] [name="add"], product-form button[name="add"], [name="add"]');
    for (var i = 0; i < addBtns.length; i++) {
      if (addBtns[i].dataset.cbBdayBoundV4 !== "1") {
        addBtns[i].dataset.cbBdayBoundV4 = "1";
        addBtns[i].addEventListener("click", atc, true);
      }
    }
    render();
  }

  document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", init) : init();
})();
